/**
 * Tour guiado COMPLETO re-lanzable (driver.js, MIT). Se dispara on-demand desde
 * "¿Cómo funciona?" / el Centro de ayuda — NO en el primer login (ese flujo es el
 * tour PROGRESIVO por sección, ver help/coach.ts, modelo elegido por Arturo).
 *
 * Los pasos y el copy salen de UN solo mapa editable (help/helpContent.ts), en
 * orden VERTICAL-FIRST: la vertical del tenant primero (un restaurante NO arranca
 * con Contactos/Flow), el resto después y lo transversal al final. Cada paso se
 * ancla al item del sidebar (`[data-tour="nav-<key>"]`); si el ancla no existe
 * (módulo/permiso), el paso se omite sin romper.
 */
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { tourEntriesFor, type HelpMe } from '../help/helpContent';

/** Pasos efectivos: contenido aplicable al tenant + ancla presente en el DOM. */
function resolveSteps(me: HelpMe) {
  return tourEntriesFor(me)
    .map((e) => ({ e, sel: `[data-tour="nav-${e.key}"]` }))
    .filter(({ sel }) => !!document.querySelector(sel)) // ancla ausente → se omite
    .map(({ e, sel }) => ({
      element: sel,
      popover: { title: e.title, description: e.coach, side: 'right' as const, align: 'start' as const },
    }));
}

/**
 * Lanza el tour completo. `onDone` se invoca SIEMPRE que se cierra (terminar,
 * saltar, Esc, X u overlay). Si no hay pasos (ningún ancla montada), llama onDone
 * y no abre nada.
 */
export function startGuidedTour(me: HelpMe, onDone: () => void): void {
  const steps = resolveSteps(me);
  if (steps.length === 0) { onDone(); return; }
  const d = driver({
    showProgress: true,
    allowClose: true,
    overlayOpacity: 0.55,
    stagePadding: 6,
    nextBtnText: 'Siguiente',
    prevBtnText: 'Anterior',
    doneBtnText: 'Listo',
    progressText: '{{current}} de {{total}}',
    steps,
    onDestroyed: () => onDone(),
  });
  d.drive();
}
